/* Enter your Custom Javascript code below without script tag */
// Company name: Developed by TechFanatic
// Website URL: https://techfanatic.in/
// Note: do not rely on jQuery — theme loads this with defer and jQuery is not guaranteed.

(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function insertAfter(newNode, referenceNode) {
    if (!newNode || !referenceNode || !referenceNode.parentNode) return;
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }

  function moveIfPresent(sourceSelector, targetSelector) {
    var source = document.querySelector(sourceSelector);
    var target = document.querySelector(targetSelector);
    if (source && target) insertAfter(source, target);
  }

  onReady(function () {
    var searchElements = document.getElementsByClassName('header__icon-wrapper');
    for (var i = 0; i < searchElements.length; i++) {
      searchElements[i].onclick = function () {
        var input = document.querySelector('.predictive-search__input');
        if (input) input.focus();
      };
    }

    setTimeout(function () {
      moveIfPresent('#trustoo-widget-wrapper', '.trustoo-reviews-widget');
      var menuBtn = document.querySelector('button[aria-controls="mobile-menu-1"]');
      var menuBtnChild = document.querySelector('button[aria-controls="mobile-menu-1-1"]');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
      if (menuBtnChild) menuBtnChild.setAttribute('aria-expanded', 'true');
      moveIfPresent('#th_product_bundle', '.product-content__tabs');
      moveIfPresent('#trustoo-widget-wrapper', '.trustoo-reviews-widget');
    }, 1500);

    moveIfPresent('#th_product_bundle', '.product-content__tabs');

    var featuredTitle = document.querySelector('p.product-content__featured-products-title.heading.heading--small');
    if (featuredTitle && !featuredTitle.querySelector('[data-tf-offer-note]')) {
      var note = document.createElement('span');
      note.setAttribute('data-tf-offer-note', 'true');
      note.style.fontSize = '20px';
      note.style.lineHeight = '35px';
      note.innerHTML = '<br>get 10% off';
      featuredTitle.appendChild(note);
    }

    var claimButtons = document.querySelectorAll(
      '.salepify-fg-advanced--gifts-only .salepify-fg-advanced__claim-button'
    );
    for (var c = 0; c < claimButtons.length; c++) {
      claimButtons[c].addEventListener('click', function () {
        setTimeout(function () {
          location.reload();
        }, 1000);
      });
    }

    var MAX_WAIT = 10000;
    var INTERVAL = 300;
    var elapsed = 0;
    var moved = false;

    function moveReviews() {
      if (moved) return false;

      var wrapper = document.querySelector(
        '.trustoo-widget-wrapper, #trustoo-widget-wrapper, [class*="trustoo-widget-wrapper"]'
      );
      var reviewsElement = wrapper || document.querySelector('[data-trustwill-reviews]');
      var targetLocation = document.getElementById('review-content');

      var hasContent =
        reviewsElement &&
        (reviewsElement.children.length > 0 || reviewsElement.innerHTML.trim() !== '');

      if (hasContent && targetLocation) {
        targetLocation.appendChild(reviewsElement);
        moved = true;
        return true;
      }
      return false;
    }

    function startPolling() {
      if (moveReviews()) return;

      var interval = setInterval(function () {
        elapsed += INTERVAL;

        if (moveReviews()) {
          clearInterval(interval);
          return;
        }

        if (elapsed >= MAX_WAIT) {
          clearInterval(interval);
        }
      }, INTERVAL);
    }

    startPolling();

    window.addEventListener('trustwill:loaded', function () {
      if (!moved) moveReviews();
    });
  });
})();
